var _clipPath, _g, _path, _ellipse;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 1.5,
    clipRule: "evenodd",
    viewBox: "0 0 75 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.084 56.257c5.699 3.593 10.058 8.436 12.324 13.482.161.398.108.846-.14 1.198a1.346 1.346 0 01-1.102.563H4.834c-.441 0-.853-.21-1.102-.563a1.255 1.255 0 01-.14-1.198c2.274-5.066 6.659-9.927 12.391-13.525l.067-.042c5.729-3.582 12.798-5.901 20.442-5.901.177 0 .521-.015.962-.015.397 0 .894.015 1.054.015 7.674 0 14.768 2.337 20.509 5.943l.067.043z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.537,
    cy: 66.507,
    className: "fill stroke",
    rx: 21.102,
    ry: 20.426
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    className: "stroke",
    d: "M53.193 71.5H4.834c-.441 0-.853-.21-1.102-.563a1.255 1.255 0 01-.14-1.198c2.274-5.066 6.659-9.927 12.391-13.525l.067-.042c5.729-3.582 12.798-5.901 20.442-5.901.177 0 .521-.015.962-.015.397 0 .894.015 1.054.015 7.674 0 14.768 2.337 20.509 5.943l.067.043c5.699 3.593 10.058 8.436 12.324 13.482.161.398.108.846-.14 1.198a1.346 1.346 0 01-1.102.563h-5.29"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 37.5,
    cy: 22.283,
    fill: "none",
    className: "stroke",
    rx: 19.404,
    ry: 18.783
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.046a7f9b1dda75a9b85dc405bdef3c1b.svg";
export { ForwardRef as ReactComponent };